/**
 * The Browse search contract (design browse-v2): the result types, the sorts and the page sizes.
 * music24-api (`browse.search`) and the web app read the same values. No imports.
 */

export const BROWSE_RESULT_TYPES = ['all', 'artists', 'tracks', 'playlists'] as const;
export type BrowseResultType = (typeof BROWSE_RESULT_TYPES)[number];

/** `match` keeps the order of the search engine. `followers` reads the artist or playlist followers. */
export const BROWSE_SORTS = ['match', 'reach', 'playlists', 'change7d', 'followers'] as const;
export type BrowseSort = (typeof BROWSE_SORTS)[number];

/** Rows per type on the All tab (design a2 note). */
export const BROWSE_PAGE_SIZE_ALL = 10;
/** Rows per page on one type. */
export const BROWSE_PAGE_SIZE_TYPE = 25;

/** Hits the server reads from the search engine per type. The counts, filters and sorts work on them. */
export const BROWSE_CANDIDATES_PER_TYPE = 100;

/** The shortest query the page sends (design: 3+ characters after 300 ms). */
export const BROWSE_MIN_QUERY_LENGTH = 3;
export const BROWSE_MAX_QUERY_LENGTH = 200;

/**
 * What it costs the user to open a row (design a1 cost chip). A followed row and a row opened today
 * open free; a playlist always opens free (owner answer 1); else it costs one browse credit.
 */
export type BrowseRowState = 'followed' | 'openedToday' | 'costsCredit' | 'free';

/** The kinds that a browse credit counts, as in the Redis set member `<kind>:<maid>`. */
export type BrowseCreditKind = 'artist' | 'track';
